(ns common.themes.registry
  (:require
   [common.themes.base :as base-theme]
   [common.themes.capman :as capman-theme]
   [potpuri.core :as potpuri]
   [common.themes.reindeer-partners :as reindeer-partners-theme]
   [common.themes.sparkmind :as sparkmind-theme]
   [common.themes.voima :as voima-theme]
   [common.themes.innovestor :as innovestor-theme]
   [common.themes.sponsor-capital :as sponsor-capital-theme]
   [common.themes.lifeline :as lifeline-theme]))

(def base :base)
(def capman :theme.lp-portal/capman)
(def reindeer-partners :theme.lp-portal/reindeer-partners)
(def voima :theme.lp-portal/voima)
(def sparkmind :theme.lp-portal/sparkmind)
(def innovestor :theme.lp-portal/innovestor)
(def sponsor-capital :theme.lp-portal/sponsor-capital)
(def lifeline :theme.lp-portal/lifeline)

(def theme-options
  {base              "LP portal base theme"
   capman            "CapMan LP portal theme"
   reindeer-partners "Reindeer partners LP portal theme"
   voima             "Voima LP portal theme"
   sparkmind         "Sparkmind LP portal theme"
   innovestor        "Innovestor LP portal theme"
   sponsor-capital   "Sponsor Capital LP portal theme"
   lifeline          "Lifeline Ventures LP portal theme"})

(def theme-lookup
  {base              base-theme/theme
   capman            (potpuri/deep-merge base-theme/theme capman-theme/theme)
   reindeer-partners (potpuri/deep-merge base-theme/theme reindeer-partners-theme/theme)
   voima             (potpuri/deep-merge base-theme/theme voima-theme/theme)
   sparkmind         (potpuri/deep-merge base-theme/theme sparkmind-theme/theme)
   innovestor        (potpuri/deep-merge base-theme/theme innovestor-theme/theme)
   sponsor-capital   (potpuri/deep-merge base-theme/theme sponsor-capital-theme/theme)
   lifeline          (potpuri/deep-merge base-theme/theme lifeline-theme/theme)})
